import React, { useEffect, useState } from "react";
import '../App.css';
import Component from '../components/Component';
import Panel from '../components/rightpanel';
import MobilePanel from '../components/MobilePanel';
import Map from '../components/Map';
import LoadingScreen from '../components/LoadingScreen';
import axios from 'axios';

const Home = ({sortType, setSortType}) => {
    const [quak, setQuak] = useState([]);
    const [selectedMag, setSelectedMag] = useState(3.5);
    const [showMap, setShowMap] = useState(false); 
    const [showList, setShowList] = useState(false); 
    const [dateFilter, setDateFilter] = useState("year");
    const [selectedMobileQuake, setSelectedMobileQuake] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                // USGS 2.5+ past month worldwide earthquakes (~2000 events)
                const response = await axios.get('https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/2.5_month.geojson');
                if (response.data && response.data.features && response.data.features.length > 0) {
                    const formatted = response.data.features.map((f, idx) => {
                        const d = new Date(f.properties.time);
                        const year = d.getFullYear();
                        const month = String(d.getMonth() + 1).padStart(2, '0');
                        const day = String(d.getDate()).padStart(2, '0');
                        const hours = String(d.getHours()).padStart(2, '0');
                        const minutes = String(d.getMinutes()).padStart(2, '0');
                        const seconds = String(d.getSeconds()).padStart(2, '0');
                        return {
                            id: f.id || String(idx + 1),
                            magnitude: String(f.properties.mag ? f.properties.mag.toFixed(1) : "0.0"),
                            depth: String(f.geometry.coordinates[2] ? Math.round(f.geometry.coordinates[2]) : "10"),
                            date: `${year}-${month}-${day}`,
                            time: `${hours}:${minutes}:${seconds}`,
                            coordinates: `${f.geometry.coordinates[0]},${f.geometry.coordinates[1]}`,
                            location: f.properties.place || "Unknown Location"
                        };
                    });
                    setQuak(formatted);
                    setTimeout(() => setIsLoading(false), 500);
                    return;
                }
            } catch (error) {
                console.warn('USGS live feed error, falling back to local dataset:', error);
            }

            try {
                const fallbackRes = await axios.get('/api/earthquakes.json');
                if (fallbackRes.data && Array.isArray(fallbackRes.data)) {
                    setQuak(fallbackRes.data);
                }
            } catch (fbError) {
                console.error('Local fallback error:', fbError);
            } finally {
                setTimeout(() => setIsLoading(false), 500);
            }
        };
        fetchData();
    }, []);

    function dateStringToComparable(str) {
        if (!str) return 0;
        const [year, month, day] = str.split('-');
        return parseInt(`${year}${month ? month.padStart(2, '0') : '01'}${day ? day.padStart(2, '0') : '01'}`, 10);
    }

    function getDateNDaysAgo(n) {
        const d = new Date();
        d.setDate(d.getDate() - n);
        d.setHours(0, 0, 0, 0);
        return d;
    }
    function isDateInRange(quakeDateStr, fromDate, toDate) {
        if (!quakeDateStr) return false;
        const quakeDate = new Date(quakeDateStr);
        return quakeDate >= fromDate && quakeDate <= toDate;
    }

    let filteredQuak = quak.filter(q => parseFloat(q.magnitude) >= selectedMag);

    const now = new Date();
    now.setHours(23, 59, 59, 999);
    if (dateFilter === "week") {
        const weekAgo = getDateNDaysAgo(7);
        filteredQuak = filteredQuak.filter(q => isDateInRange(q.date, weekAgo, now));
    } else if (dateFilter === "month") {
        const monthAgo = getDateNDaysAgo(30);
        filteredQuak = filteredQuak.filter(q => isDateInRange(q.date, monthAgo, now));
    } else if (dateFilter === "year") {
        const yearAgo = getDateNDaysAgo(365);
        filteredQuak = filteredQuak.filter(q => isDateInRange(q.date, yearAgo, now));
    }

    const sortedQuak =  [...filteredQuak].sort((a, b) => {
        if (sortType === "largest") return b.magnitude - a.magnitude;
        if (sortType === "oldest") return dateStringToComparable(a.date) - dateStringToComparable(b.date);
        if (sortType === "newest") return dateStringToComparable(b.date) - dateStringToComparable(a.date);
        return 0;
    });

    return (
        <div>
            <LoadingScreen isLoading={isLoading} />
            <MobilePanel 
                setShowMap={setShowMap} 
                showMap={showMap} 
                setShowList={setShowList}
                sortType={sortType}
                setSortType={setSortType}
                dateFilter={dateFilter}
                setDateFilter={setDateFilter}
                selectedMobileQuake={selectedMobileQuake}
            />

            <Component
                className={`z-20 mt-[-20px] block sm:hidden overflow-hidden rounded-t-3xl h-[680px] ${showMap ? 'hidden' : ''}`}
                quak={sortedQuak}
            />

            <div id="main" className='float-right w-[20%] sm:w-[50%] md:w-[40%] lg:w-[35%] xl:w-[20%] inline-block'>
              <Panel
                quak={sortedQuak}
                setSortType={setSortType}
                selectedMag={selectedMag}
                setSelectedMag={setSelectedMag}
                dateFilter={dateFilter}
                setDateFilter={setDateFilter}
              />
              <Component className='hidden sm:block w-full overflow-hidden h-[640px]' quak={sortedQuak} />
            </div>
            <Map showMap={showMap} onQuakeSelectMobile={setSelectedMobileQuake} quak={sortedQuak} />
        </div>
    );
};

export default Home;